// ============================================================================
// FALLBACK / OFFLINE DATA — Victoria Resin Store
// ----------------------------------------------------------------------------
// Everything in this file is used ONLY when REACT_APP_USE_LIVE_API=false or
// when a live API call fails (see services/api.js -> callOrMock).
// All real content — products, categories, site settings, testimonials,
// shapes, banners — is managed from the admin panel. Do NOT edit this file
// expecting changes to appear on the live site.
// ============================================================================

const dining = [
  'https://images.unsplash.com/photo-1633435597188-27c1e70f329d?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1617638924751-cc232f82ecf9?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1615529162924-f8605388461d?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1617638717732-a3ef01769ff2?auto=format&fit=crop&w=1200&q=80',
  'https://images.unsplash.com/photo-1614597445336-8a67e9314d91?auto=format&fit=crop&w=1200&q=80',
];
const clocks = [
  'https://images.pexels.com/photos/11066021/pexels-photo-11066021.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.pexels.com/photos/7258058/pexels-photo-7258058.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.pexels.com/photos/7256845/pexels-photo-7256845.jpeg?auto=compress&cs=tinysrgb&w=1200',
  'https://images.pexels.com/photos/1181419/pexels-photo-1181419.jpeg?auto=compress&cs=tinysrgb&w=1200',
];

// ---------------------------------------------------------------------------
// Hero slides — fallback for getHeroSlides(). Real slides: admin > Banners.
// ---------------------------------------------------------------------------
export const heroSlides = [
  {
    title: 'Handcrafted Epoxy Resin Art',
    subtitle: 'India\u2019s No.1 Resin Brand \u2014 Where wood meets waves.',
    cta: 'Shop Collection',
    image: 'https://images.unsplash.com/photo-1633435597188-27c1e70f329d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxlcG94eSUyMHJlc2luJTIwdGFibGV8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85',
  },
  {
    title: 'Ocean Shore Dining Collection',
    subtitle: 'Bring the sea home \u2014 live-edge epoxy dining tables.',
    cta: 'Explore Dining Tables',
    image: 'https://images.unsplash.com/photo-1617638924751-cc232f82ecf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxlcG94eSUyMHJlc2luJTIwdGFibGV8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85',
  },
];

// ---------------------------------------------------------------------------
// Testimonials — fallback for getTestimonials(). Real data: admin > Testimonials.
// ---------------------------------------------------------------------------

export const testimonials = [
  {
    name: 'Ananya Sharma',
    city: 'Boral, Garia',
    text: 'I ordered a beautiful resin table from Victoria Resin Store. The finish was premium and the design looked amazing in my living room.',
    rating: 5
  },
  {
    name: 'Rahul Das',
    city: 'Garia',
    text: 'Really impressed with the quality of the resin artwork. The finishing was smooth and the product looked exactly as expected.',
    rating: 5
  },
  {
    name: 'Priya Sen',
    city: 'Boral, Garia',
    text: 'I purchased a customized resin nameplate and absolutely loved it. The detailing and glossy finish were excellent.',
    rating: 5
  },
  {
    name: 'Sourav Roy',
    city: 'Garia',
    text: 'Victoria Resin Store has beautiful and unique resin products. My home décor piece looks elegant and premium.',
    rating: 4.8
  },
  {
    name: 'Neha Mukherjee',
    city: 'Boral',
    text: 'The resin artwork was beautifully crafted and carefully packed. Very happy with the overall quality.',
    rating: 5
  },
  {
    name: 'Amit Ghosh',
    city: 'Garia',
    text: 'Ordered a customized resin gift for a special occasion. The final product was beautiful and very well finished.',
    rating: 5
  },
  {
    name: 'Riya Chatterjee',
    city: 'Boral, Garia',
    text: 'Loved the unique resin design and beautiful finishing. It added a premium touch to my home.',
    rating: 4.8
  },
  {
    name: 'Arindam Sen',
    city: 'Garia',
    text: 'The resin table looks fantastic. The colors, finishing and craftsmanship are really impressive.',
    rating: 5
  },
  {
    name: 'Moumita Roy',
    city: 'Boral',
    text: 'Beautiful resin art with excellent detailing. The product looks classy and perfectly matches my home décor.',
    rating: 5
  },
  {
    name: 'Abhishek Dutta',
    city: 'Garia',
    text: 'Very happy with my resin purchase. The quality is excellent and the finishing gives it a premium appearance.',
    rating: 4.8
  },
  {
    name: 'Sneha Banerjee',
    city: 'Boral, Garia',
    text: 'I loved the customized resin artwork. The colors were beautiful and the final finish was outstanding.',
    rating: 5
  },
  {
    name: 'Sayan Chakraborty',
    city: 'Garia',
    text: 'The resin décor piece exceeded my expectations. Great craftsmanship and a beautiful glossy finish.',
    rating: 5
  },
  {
    name: 'Tania Ghosh',
    city: 'Boral',
    text: 'Ordered a resin gift for my parents and they loved it. It was beautifully designed and packed safely.',
    rating: 5
  },
  {
    name: 'Debanjan Roy',
    city: 'Garia',
    text: 'Excellent resin work and very attractive design. The product looks even better in person.',
    rating: 4.8
  },
  {
    name: 'Roshni Das',
    city: 'Boral, Garia',
    text: 'The customized resin piece was exactly what I wanted. Beautiful colors, smooth finish and great detailing.',
    rating: 5
  },
  {
    name: 'Kunal Saha',
    city: 'Garia',
    text: 'Very impressed with the resin table quality. It looks stylish and gives my room a completely different look.',
    rating: 5
  },
  {
    name: 'Poulomi Sen',
    city: 'Boral',
    text: 'The resin artwork is gorgeous. The combination of colors and finishing is absolutely beautiful.',
    rating: 5
  },
  {
    name: 'Ritwik Das',
    city: 'Garia',
    text: 'Good quality resin product with excellent finishing. The packaging was also very secure.',
    rating: 4.8
  },
  {
    name: 'Ishita Roy',
    city: 'Boral, Garia',
    text: 'I ordered a customized resin décor item and was very pleased with the result. Highly recommended.',
    rating: 5
  },
  {
    name: 'Soumya Mukherjee',
    city: 'Garia',
    text: 'Beautiful craftsmanship and premium quality. The resin design looks elegant and modern.',
    rating: 5
  },
  {
    name: 'Rajib Ghosh',
    city: 'Boral',
    text: 'The resin table has a stunning finish and looks fantastic in my home. Very satisfied with the purchase.',
    rating: 5
  },
  {
    name: 'Madhumita Das',
    city: 'Garia',
    text: 'Loved the customized resin artwork. The detailing was excellent and the product was delivered safely.',
    rating: 4.8
  },
  {
    name: 'Arnab Sen',
    city: 'Boral, Garia',
    text: 'The product quality is excellent. The resin finish is smooth, shiny and gives a premium feel.',
    rating: 5
  },
  {
    name: 'Sohini Roy',
    city: 'Garia',
    text: 'Beautiful resin décor and very good craftsmanship. It looks perfect on my living room table.',
    rating: 5
  },
  {
    name: 'Aritra Banerjee',
    city: 'Boral',
    text: 'I am very happy with my resin purchase. The design is unique and the finishing is excellent.',
    rating: 4.8
  },
  {
    name: 'Payel Saha',
    city: 'Garia',
    text: 'The customized resin product was beautiful and carefully made. It made a wonderful gift.',
    rating: 5
  },
  {
    name: 'Rohan Dutta',
    city: 'Boral, Garia',
    text: 'Excellent quality and attractive design. The resin artwork has added a beautiful touch to my home.',
    rating: 5
  },
  {
    name: 'Nandita Ghosh',
    city: 'Garia',
    text: 'The resin product looks premium and beautifully finished. I am very satisfied with the overall experience.',
    rating: 5
  },
  {
    name: 'Sourav Banerjee',
    city: 'Boral',
    text: 'Great resin craftsmanship and excellent finishing. The product looks exactly like the pictures.',
    rating: 4.8
  },
  {
    name: 'Debosmita Roy',
    city: 'Garia',
    text: 'Absolutely loved my resin décor piece. The colors are beautiful and the finish is very smooth.',
    rating: 5
  },
  {
    name: 'Anirban Saha',
    city: 'Boral, Garia',
    text: 'The resin table is beautifully designed and feels very premium. Excellent addition to my home.',
    rating: 5
  },
  {
    name: 'Tumpa Das',
    city: 'Garia',
    text: 'I ordered a customized resin gift and the result was amazing. Beautiful work and great attention to detail.',
    rating: 5
  },
  {
    name: 'Siddhartha Roy',
    city: 'Boral',
    text: 'Very good resin quality and professional finishing. The product looks elegant and durable.',
    rating: 4.8
  },
  {
    name: 'Mitali Sen',
    city: 'Garia',
    text: 'The resin artwork is stunning and looks wonderful as a home decoration. Loved the overall design.',
    rating: 5
  },
  {
    name: 'Pratik Ghosh',
    city: 'Boral, Garia',
    text: 'Excellent craftsmanship. The resin finish is glossy and the product has a very premium appearance.',
    rating: 5
  },
  {
    name: 'Rupsa Dutta',
    city: 'Garia',
    text: 'Beautiful customized resin work. The product was well packed and arrived in perfect condition.',
    rating: 5
  },
  {
    name: 'Niloy Chakraborty',
    city: 'Boral',
    text: 'Really liked the quality and unique design. Victoria Resin Store has some excellent resin products.',
    rating: 4.8
  },
  {
    name: 'Sreya Banerjee',
    city: 'Garia',
    text: 'The resin décor item looks beautiful in my home. Very neat finishing and attractive colors.',
    rating: 5
  },
  {
    name: 'Avik Roy',
    city: 'Boral, Garia',
    text: 'I was impressed with the quality of the resin table. The design is modern and the finish is excellent.',
    rating: 5
  },
  {
    name: 'Rima Ghosh',
    city: 'Garia',
    text: 'Ordered a customized resin artwork and absolutely loved it. Beautiful design and excellent craftsmanship.',
    rating: 5
  },
  {
    name: 'Sagnik Das',
    city: 'Boral',
    text: 'Very satisfied with my purchase. The resin product is well made, attractive and has a premium finish.',
    rating: 4.8
  },
  {
    name: 'Shreya Mukherjee',
    city: 'Garia',
    text: 'The resin artwork looks gorgeous. The colors blend beautifully and the finishing is very professional.',
    rating: 5
  },
  {
    name: 'Kaushik Sen',
    city: 'Boral, Garia',
    text: 'Excellent product quality and beautiful design. It has become one of my favorite home décor pieces.',
    rating: 5
  },
  {
    name: 'Debolina Roy',
    city: 'Garia',
    text: 'The customized resin item turned out beautifully. Great attention to detail and very good finishing.',
    rating: 5
  },
  {
    name: 'Mainak Ghosh',
    city: 'Boral',
    text: 'Loved the premium look of the resin product. The craftsmanship is excellent and the design is unique.',
    rating: 4.8
  },
  {
    name: 'Ritika Das',
    city: 'Garia',
    text: 'Beautiful resin work and excellent quality. The product was safely packed and arrived without any damage.',
    rating: 5
  },
  {
    name: 'Souvik Roy',
    city: 'Boral, Garia',
    text: 'The resin table looks amazing and gives my room a luxurious feel. Very happy with the purchase.',
    rating: 5
  },
  {
    name: 'Moumita Sen',
    city: 'Garia',
    text: 'Wonderful resin craftsmanship and beautiful finishing. The customized design was exactly what I wanted.',
    rating: 5
  },
  {
    name: 'Partha Banerjee',
    city: 'Boral',
    text: 'Excellent resin quality and professional work. The product looks premium and is beautifully finished.',
    rating: 4.8
  },
  {
    name: 'Sanjana Ghosh',
    city: 'Garia',
    text: 'I loved the resin artwork I purchased. It is unique, elegant and adds a beautiful touch to my décor.',
    rating: 5
  },
  {
    name: 'Rajdeep Saha',
    city: 'Boral, Garia',
    text: 'Very happy with Victoria Resin Store. The resin product is beautifully crafted and the finishing is outstanding.',
    rating: 5
  },
  {
    name: 'Swati Roy',
    city: 'Garia',
    text: 'The product quality was excellent and the design was beautiful. Definitely a great choice for resin décor.',
    rating: 5
  }
];



// ---------------------------------------------------------------------------
// Search suggestions — fallback for searchProducts(). Real data: admin > Search Terms.
// ---------------------------------------------------------------------------
export const searchSuggestions = [
  'red roses bouquet',
  'birthday flower bouquet',
  'anniversary flowers',
  'fresh flower bouquet',
  'same day flower delivery',
  'premium flower bouquet',
  'orchid bouquet',
  'flower delivery in Mumbai',
];

// ---------------------------------------------------------------------------
// Video testimonials — fallback for getVideoTestimonials(). Real data: admin > Video Testimonials.
// ---------------------------------------------------------------------------
export const videoTestimonials = [
  { id: 'v1', thumb: 'https://images.unsplash.com/photo-1587533042502-1209d3f2d891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxyZXNpbiUyMHdhbGwlMjBhcnR8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85', title: 'Reactions before delivery',     customer: 'Ananya S.' },
  { id: 'v2', thumb: 'https://images.unsplash.com/photo-1715619048248-4c0c3ece2230?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxyZXNpbiUyMHdhbGwlMjBhcnR8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85', title: 'Unboxing the ocean wall art',    customer: 'Riya K.'   },
  { id: 'v3', thumb: 'https://images.pexels.com/photos/11066021/pexels-photo-11066021.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', title: 'Make every wall a canvas',       customer: 'Vikram R.' },
  { id: 'v4', thumb: 'https://images.pexels.com/photos/7258058/pexels-photo-7258058.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',   title: 'Living room makeover',           customer: 'Priya N.'  },
];

// ---------------------------------------------------------------------------
// Shop by shape — fallback for getShapes(). Real data: admin > Shapes.
// ---------------------------------------------------------------------------
export const shapes = [
  { id: 'round',       name: 'Round',       image: clocks[0] },
  { id: 'rectangular', name: 'Rectangular', image: dining[3] },
  { id: 'square',      name: 'Square',      image: 'https://images.unsplash.com/photo-1587533042502-1209d3f2d891?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxyZXNpbiUyMHdhbGwlMjBhcnR8ZW58MHx8fHwxNzg1OTQzOTM5fDA&ixlib=rb-4.1.0&q=85' },
  { id: 'oval',        name: 'Oval',        image: dining[3] },
];